<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <!-- <feather-icon
      icon="EyeIcon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="viewRecord"
    /> -->
    <feather-icon
      v-if="user_role == 'Owner' || user_role == 'Admin'"
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord"
    />
    <feather-icon
      v-if="user_role == 'Owner' || user_role == 'Admin'"
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord"
    />
  </div>
</template>

<script>
import { database } from "firebase";
import DataProvider from "../../../../../services/data-provider";
import { bus } from "../../../../../main";

export default {
  name: "CellRendererActions",
  // props:{
  //   user_role:{
  //     type:String
  //   }
  // },
  data() {
    return {
      user_role: "",
    };
  },
  created() {
      console.log("this.user_role:",this.user_role)
    DataProvider.getCurrentAuthUser().then(
      (res) => {
        console.log("results:", res);
        this.user_role = res.claims.role ? res.claims.role : "";
        console.log(this.user_role)
      },
      (err) => {
        console.log("error:", err);
      }
    );
  },
  methods: {
    viewRecord() {
      this.$router
        .push("/apps/user/user-view/" + this.params.data.uid)
        .catch(() => {});
    },
    editRecord() {
      // this.$router.push(`/apps/user/user-edit/${268}`).catch(() => {});
      this.$router
        .push("/apps/user/user-edit/" + this.params.data.uid)
        .catch(() => {});
      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
    },
    confirmDeleteRecord() {
      bus.$emit("deleteUser", {
        name: this.params.data.name,
        uid: this.params.data.uid,
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      // DataProvider.deleteData("users", this.params.data.uid).then(
      //   (data) => {
      DataProvider.deleteUser("/users/", this.params.data.uid).then(
        (res) => {
          console.log(res);
          this.showDeleteSuccess();

          // })
        },
        (err) => {
          console.log("error:", err);
        }
      );

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "User Deleted",
        text: "The selected user was successfully deleted",
      });
    },
  },
};
</script>
